// import _ from 'lodash'

export const tableMixin = {
    data() {
        return {
            pagination: {
                total: 0,
                currentPage: 1,
                pageOption: [],
                pageSize: 10,
                pageSizeOption: [10, 20, 30, 40, 50],
            },
            extra: {},
            tableData: [],
        }
    },
    computed: {
        params() {
            const extraParams = this.extra || {}
            return {
                skip: (this.pagination.currentPage - 1) * this.pagination.pageSize,
                limit: this.pagination.pageSize,
                ...extraParams
            }
        }
    },
    methods: {
        refreshList() {
            this.requestList(this.params)
        },
        refreshList1() {
            if (this.pagination.currentPage > 1 && this.pagination.total - 1 <= (this.pagination.currentPage - 1) * this.pagination.pageSize) {
                this.pagination.currentPage -= 1
            } else {
                this.requestList(this.params)
            }
        },
        updateData(payload) {
            this.tableData = payload.data
            this.pagination.total = payload.total;
            this.setPageOption()
        },
        setPageOption() {
            this.pagination.pageOption = []
            let numberOfPages = Math.ceil(this.pagination.total / this.pagination.pageSize);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pagination.pageOption.push(index);
            }
        }
    },
    watch: {
        'pagination.pageSize': {
            handler(val) {
                if (val) {
                    this.requestList(this.params)
                }
            }
        },
        'pagination.currentPage': {
            immediate: true,
            deep: true,
            handler() {
                this.requestList(this.params)
            }
        },
        extra: {
            immediate: true,
            deep: true,
            handler() {
                if (this.pagination.currentPage == 1) {
                    this.requestList(this.params)
                } else {
                    this.pagination.currentPage = 1
                }
            }
        }
    }
}
